import { useState, useCallback } from 'react';

export const useFilters = () => {
  const [filterType, setFilterType] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const handleFilterChange = useCallback((newFilter) => {
    setFilterType(newFilter);
  }, []);

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  return {
    filterType,
    searchTerm,
    handleFilterChange,
    handleSearch
  };
};
